<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">
      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
          <div class="login">
            <component :is="passwordComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { every } from 'lodash'
  import EmailForm from 'components/password/EmailForm'
  import PasswordForm from 'components/password/PasswordForm'
  import $ from 'jquery'

  export default {
    components: {
      EmailForm,
      PasswordForm
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    computed: {
      /**
       * The component we need to use based on whether or not we have query string data.
       *
       * @return string
       */
      passwordComponent () {
        if (every(['token', 'email'], key => key in this.$route.query)) {
          return 'password-form'
        }

        return 'email-form'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?55144415